import type React from 'react';

import { useTheme } from '@mui/material';
import { MiniMap } from '@xyflow/react';

/**
 * Renders a mini map of the dialplan.
 *
 * @return {React.ReactElement} The JSX element representing the mini map.
 */
const DialplanMiniMap = (): React.ReactElement => {
  const theme = useTheme();

  return (
    <>
      <MiniMap
        style={{
          borderRadius: theme.shape.borderRadius,
          border: `1px solid ${theme.palette.text.primary}`,
          overflow: 'hidden',
          left: theme.spacing(3),
          bottom: theme.spacing(2.5),
          margin: 0,
        }}
        nodeColor={(node) => theme.palette.dialplan[node.type as keyof typeof theme.palette.dialplan]}
        nodeStrokeWidth={10}
        position='bottom-left'
        zoomable
        pannable
      />
    </>
  );
};

export default DialplanMiniMap;
